import {DPlexArguments} from './DPlexArguments';

declare var Drupal:any;

export abstract class AbstractTransitionManager {

    constructor () {
        $(document).on('nav',(ev,args)=>this.navigate(args));
    }

    public abstract navigate(args:DPlexArguments):void;

    public updateZone(args:DPlexArguments,zone:string) {
        let element=$('[data-zone="'+zone+'"]');
        let zoneElement=$(args.zones[zone]);
        element.replaceWith(zoneElement);
        Drupal.attachBehaviors(zoneElement[0]);
        $(document).trigger('zone.update');
        return element;
    }

}

export {};